<div class="quiz-container" *ngIf="currentQuestion">
  <div class="quiz-header">
    <div class="question-counter">
      <span class="current">{{questionNumber | arabicNumber:currLang}}</span>
      <span class="separator">/</span>
      <span class="total">{{totalQuestions | arabicNumber:currLang}}</span>
    </div>
    <div class="quiz-header-actions">
      <app-game-sound-control></app-game-sound-control>
      <app-quiz-timer [value]="timerValue" [max]="currentQuestion.timeLimit" [currLang]="currLang"></app-quiz-timer>
    </div>
    <!-- Phase 2: Creature mini display (hidden for Phase 1)
    <div class="creature-mini" *ngIf="creature">
      <app-creature-display
        [creatureTypeId]="creature.creatureTypeId"
        [pose]="'idle'"
        [level]="creature.level"
        [size]="'small'">
      </app-creature-display>
    </div>
    -->
  </div>

  <app-question-card
    [question]="currentQuestion"
    [selectedOption]="selectedOption"
    (optionSelected)="selectOption($event)">
  </app-question-card>

  <div class="quiz-footer">
    <button
      class="submit-btn"
      [class.active]="selectedOption"
      [disabled]="!selectedOption || isSubmitting"
      (click)="submitAnswer()">
      {{'game-mode.quiz.submit' | translate}}
    </button>
  </div>
</div>
